import { ca } from '@cian/analytics';

export const trackOtherDevelopersShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'show_other_builders',
    useLastProducts: true,
  });
};

export const trackOtherDevelopersClick = (builderId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'click_other_builder',
    label: builderId,
    useLastProducts: true,
  });
};
